var React = require('react');

function IconSmArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M15 7.332L13.668 6 8 11.668l5.668 5.668L15 16l-4.327-4.336z","transform":"translate(-8 -6)"}));
}

IconSmArrowLeft.defaultProps = {"width":"7","height":"12","viewBox":"0 0 7 12"};

module.exports = IconSmArrowLeft;

IconSmArrowLeft.default = IconSmArrowLeft;
